<div class="row" class="table-row">
  <table mat-table [dataSource]="substances" class="mat-elevation-z8">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getNameText() }}
      </th>
      <td mat-cell *matCellDef="let substance" class="substance-name-cell">
        {{ substance.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="casNumber">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getCasNumberText() }}
      </th>
      <td mat-cell *matCellDef="let substance">{{ substance.casNumber }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
